export var CrewRole;
(function (CrewRole) {
    CrewRole["FE"] = "FE";
    CrewRole["FI"] = "FI";
    CrewRole["LTE"] = "LTE";
    CrewRole["LTI"] = "LTI";
    CrewRole["PF"] = "PF";
    CrewRole["PICUS"] = "PICUS";
    CrewRole["PM"] = "PM";
    CrewRole["SICUS"] = "SICUS";
    CrewRole["SPIC"] = "SPIC";
    CrewRole["studentDual"] = "STUDENT-DUAL";
    CrewRole["studentSolo"] = "STUDENT-SOLO";
    CrewRole["supervisinginstructor"] = "SUPERVISING-INSTRUCTOR";
})(CrewRole || (CrewRole = {}));
export const CREW_ROLE_PF = CrewRole.PF;
export const CREW_ROLE_PM = CrewRole.PM;
export const CREW_ROLE_FI = CrewRole.FI;
export const CREW_ROLE_FE = CrewRole.FE;
export const CREW_ROLE_LTI = CrewRole.LTI;
export const CREW_ROLE_LTE = CrewRole.LTE;
export const CREW_ROLE_STUDENT_SOLO = CrewRole.studentSolo;
export const CREW_ROLE_STUDENT_DUAL = CrewRole.studentDual;
export const CREW_ROLE_SPIC = CrewRole.SPIC;
export const CREW_ROLE_PICUS = CrewRole.PICUS;
export const CREW_ROLE_SICUS = CrewRole.SICUS;
export const CREW_ROLE_SUPERVISING_INSTRUCTOR = CrewRole.supervisinginstructor;
export const getAllRoles = () => [
    CREW_ROLE_PF,
    CREW_ROLE_PM,
    CREW_ROLE_FI,
    CREW_ROLE_FE,
    CREW_ROLE_LTI,
    CREW_ROLE_LTE,
    CREW_ROLE_STUDENT_SOLO,
    CREW_ROLE_STUDENT_DUAL,
    CREW_ROLE_SPIC,
    CREW_ROLE_PICUS,
    CREW_ROLE_SICUS,
    CREW_ROLE_SUPERVISING_INSTRUCTOR,
];
export const getPfPmRoles = () => [CREW_ROLE_PF, CREW_ROLE_PM];
export const getPicRoles = (isAto, isCatAble) => {
    if (isAto) {
        return [CREW_ROLE_STUDENT_SOLO, CREW_ROLE_FI, CREW_ROLE_FE];
    }
    else if (isCatAble) {
        return [CREW_ROLE_LTI, CREW_ROLE_LTE];
    }
    return [];
};
export const getSicRoles = (isAto, picRoles, isMcc) => {
    if (isAto) {
        if (picRoles.some(isRoleInstructorLike)) {
            return [CREW_ROLE_STUDENT_DUAL, CREW_ROLE_SPIC];
        }
        else if (picRoles.includes(CREW_ROLE_STUDENT_SOLO)) {
            return [CREW_ROLE_SUPERVISING_INSTRUCTOR];
        }
        return [];
    }
    else if (picRoles.some(isRoleLineTrainingInstructorLike)) {
        if (isMcc) {
            return [CREW_ROLE_PICUS, CREW_ROLE_SICUS];
        }
        return [CREW_ROLE_PICUS];
    }
    return [];
};
export const isRoleInstructorLike = (role) => {
    return [CREW_ROLE_FE, CREW_ROLE_FI].includes(role);
};
export const isRoleLineTrainingInstructorLike = (role) => {
    return [CREW_ROLE_LTE, CREW_ROLE_LTI].includes(role);
};
//# sourceMappingURL=CrewRoleTypes.js.map